'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import FormatQuote from '@/assets/images/format_quote.png';
import InspirationalQuoteDragon from '@/assets/images/InspirationalQuote-dragon.png';
import MoInspirationalQuoteDragon from '@/assets/images/MO-InspirationalQuote-dragon.png';
export default function InspirationalQuote() {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Image src={InspirationalQuoteDragon} alt="" aria-hidden="true" className="hidden sm:block absolute left-[-10%] max-w-[30vw] top-[36%] pointer-events-none rotate-[-165deg]" />;
    t1 = <Image src={MoInspirationalQuoteDragon} alt="" aria-hidden="true" className="block sm:hidden absolute right-0 max-w-[165px] top-[43%] pointer-events-none" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src={FormatQuote} alt="quote" className="mb-5.5 2xl:w-10.5 xl:w-9 lg:w-8 w-5.5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section id="inspirational-quote" className="pt-5 lg:mb-0 md:mb-5 sm:mb-10 mb-20"><div className="relative bg-black scroll-mt-20 2xl:rounded-[40px] xl:rounded-[32px] lg:rounded-[28px] md:rounded-[24px] rounded-[20px]">{t0}{t1}<div className="container-wrap w-full 2xl:py-35 xl:py-28 lg:py-20 md:py-16 py-15 "><div className="max-w-[calc(100vw-90px)] sm:max-w-[75vw] lg:max-w-[65vw] xl:max-w-[827px] 2xl:max-w-[calc(2vw+827px)] ml-0 [@media(min-width:1750px)] w-full sm:mx-auto sm:pl-[16vw] lg:pl-[10vw] xl:pl-[8.5vw] [@media(min-width:1540px)]:pl-[5vw] [@media(min-width:1750px)]:pl-[2vw] ">{t2}<h2 className="relative z-10 2xl:text-[50px] xl:text-[42px] lg:text-[36px] text-[26px] text-white leading-[1.12] font-semibold">Parade of Hearts is more than art on display — it's a symbol of Kansas City's unity. Each sculpture represents a unique story, but{" "}<span className="text-[#00EAFD]">together they showcase the strength, compassion, and creativity that define our community.</span></h2></div></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}